import { IncomeCalculationType } from 'constants/proForma';
import { isLandDevelopmentModel } from 'helpers/proForma';
import {
    formatAssumptions, formatDevelopment, formatForecast, formatLandDevelopmentAssumptions,
    formatLandDevelopmentDispositionSchedule, formatLandDevelopmentForecast, formatLandDevelopmentReturns,
    formatOperations, formatReturns,
} from './helpers';
import { legacyDetailSections } from './legacyDetailSections';
import { ProFormaSummaryData, SummaryBlocks } from './types';

/**
 * The Executive Summary for every asset type that is not yet on the shared layout. Apartment goes
 * through `buildBlocks`; this keeps the per-asset formatters exactly as they were for the rest.
 */
export const legacyBlocks = (data: ProFormaSummaryData): SummaryBlocks => {
    const {
        proForma, incomeSummary, operatingInfo, expenses, wattsType,
        uses, sources, disposition, permanentDebtInfo, returnsData, waterfallAnalysis, reportMetrics,
    } = data;
    const isLandDev = isLandDevelopmentModel(proForma.proFormaModelId);
    const hasReturns = !!returnsData && Object.keys(returnsData).length > 0;

    return {
        details: legacyDetailSections(data),
        assumptions: isLandDev
            ? formatLandDevelopmentAssumptions(reportMetrics, disposition, proForma.totalInitialTake, proForma.totalRecurringNum)
            : formatAssumptions(proForma.proFormaModelId, incomeSummary, operatingInfo, expenses, wattsType),
        forecast: isLandDev
            ? formatLandDevelopmentForecast(reportMetrics, returnsData)
            : formatForecast(disposition!, operatingInfo, permanentDebtInfo!, returnsData!),
        returns: isLandDev
            ? formatLandDevelopmentReturns(returnsData, waterfallAnalysis)
            : (hasReturns ? formatReturns(returnsData!, waterfallAnalysis!) : []),
        development: formatDevelopment(proForma.proFormaModelId, uses, sources),
        operations: isLandDev
            ? formatLandDevelopmentDispositionSchedule(reportMetrics, disposition)
            : formatOperations(
                proForma.proFormaModelId,
                disposition!,
                operatingInfo?.incomeCalculationType as IncomeCalculationType,
                wattsType,
            ),
    };
};
